/*
 * @Author: mrzou
 * @Date: 2021-06-18 15:08:22
 * @LastEditors: mrzou
 * @LastEditTime: 2021-08-16 14:52:48
 * @Description: file content
 */

const uni = process.client ? window : {}
let Vm = null
const PageMap = {
  '/guide': 'd1',
  '/integralRules': 'd2',
  '/integralStatistics': 'd3',
  '/operateActivity': 'd4',
  '/partner': 'd5',
  '/preHeating': 'd6',
  '/rewardDescription': 'd7',
  '/taskhall': 'd8',
  '/test-fetch-api': 'd9',
  '/typeDetails': 'd10',
  '/wechat': 'd11',
  '/headlineCollege/article': 'd12',
  '/headlineCollege/doctor': 'd13',
  '/integration/integration-cash': 'd14',
  '/integration/integration-detail': 'd15',
  '/integration/my-integration': 'd16',
  '/integration/reward-details': 'd17',
  '/operateActivity/rule': 'd18',
  '/partner/cashout': 'd19',
  '/partner/detail': 'd20',
  '/partner/history': 'd21',
  '/partner/index1': 'd22',
  '/partner/plan': 'd23',
  '/partner/receive': 'd24',
  '/partner/record': 'd25',
  '/partner/success': 'd26',
  '/patient/display': 'd27',
  '/patient/kw-subject': 'd28',
  '/posters/jiezhenjiqiao': 'd29',
  '/posters/liuliangfuchi': 'd30',
  '/qa/daily': 'd31',
  '/qa/newhand': 'd32',
  '/qa/profit': 'd33',
  '/qa/rule': 'd34',
  '/taskhall/finance_details': 'd35',
  '/taskhall/latest-events': 'd36',
  '/taskhall/level': 'd37',
  '/taskhall/level-swiper': 'd38',
  '/taskhall/my_badge': 'd39',
  '/taskhall/partner': 'd40',
  '/taskhall/share_banner': 'd41',
  '/taskhall/task-explain': 'd42',
  '/taskhall/total-task-progress': 'd43',
  '/wechat/display': 'd44',
  '/wechat/push': 'd45',
  '/wechat/reason': 'd46',
  '/wechat/request': 'd47',
  '/wechat/success': 'd48',
  '/headlineCollege/components/KwButton': 'd49',
  '/headlineCollege/components/KwTitleCard': 'd50',
  '/headlineCollege/components/KwVideoHead': 'd51',
  '/headlineCollege/components/tipBox': 'd52',
  '/headlineCollege/components/tipModal': 'd53',
  '/headlineCollege/doctor/join-application': 'd54',
  '/headlineCollege/doctor/success': 'd55',
  '/integralStatistics/components/statistics-item': 'd56',
  '/operateActivity/components/completeText': 'd57',
  '/operateActivity/components/floatBall': 'd58',
  '/partner/components/weelyReport': 'd59',
  '/taskhall/components/activity-banner': 'd60',
  '/taskhall/components/activity-list': 'd61',
  '/taskhall/components/beanProgressBar': 'd62',
  '/taskhall/components/kw-echart': 'd63',
  '/taskhall/components/qian-dao': 'd64',
  '/taskhall/components/task-item': 'd65',
  '/taskhall/components/task-item-line': 'd66',
  '/typeDetails/compoents/type-details-item': 'd67',
  '/': 'd68',
  '/taskhall/sign-in-strategy': 'd69'
}

export const CidMap = {
  clickSign: 'd_01', // app首页-签到领银豆-点击签到
  clickExchangeGiftPop: 'd_02', // 首页-签到领银豆-点击签到-兑换礼品（弹窗）
  clickExchangeGift: 'd_03', // 首页-签到领银豆-兑换礼品
  clickUpgradeCash: 'd_04', // 首页-签到领银豆-升级领现金
  releaseComment: 'd_05', // 患者评论列表-发布评论
  removeComment: 'd_06' // 患者评论列表-发布评论
}

const sendPageTrack = async data => {
  await Vm.$axios({
    method: 'post',
    url: '/collect/access/point',
    data
  })
}
const sendClickTrack = async data => {
  await Vm.$axios({
    method: 'post',
    url: '/collect/click/point',
    data
  })
}

function saveHistory(vm) {
  const {
    $route: { path, query }
  } = vm
  let Pages
  let sameIndex = -1

  try {
    Pages = JSON.parse(sessionStorage.getItem('kwPages') || '[]')
  } catch (e) {
    Pages = []
  }

  if (~(sameIndex = Pages.findIndex(v => v.url === path)) && sameIndex >= 0) {
    Pages = Pages.slice(0, sameIndex)
  }

  sessionStorage.setItem(
    'kwPages',
    JSON.stringify([
      ...Pages,
      {
        url: path,
        options: query
      }
    ])
  )

  // 是否找到了相同的路径，有的话应该是回退页面
  // doctor2中回退也会重新执行mount
  return sameIndex
}

function getPages() {
  try {
    const pages = sessionStorage.getItem('kwPages')
    return pages && pages.length ? JSON.parse(pages) : []
  } catch (e) {
    return []
  }
}

uni.getLaunchOptionsSync =
  uni.getLaunchOptionsSync ||
  (() => {
    return { scene: '' }
  })

let mpgReportData = null

export const getOptions = () => {
  try {
    const Pages = getPages()
    const LastPage = Pages.slice(-1)[0]
    const Opt = (LastPage && LastPage.options) || ''
    const KwFrom = Opt.kw_from || sessionStorage.getItem('kwPagesKwFrom') || ''
    // LastPage?.options?.kw_from || sessionStorage.getItem('kwPagesKwFrom') || ''

    KwFrom && sessionStorage.setItem('kwPagesKwFrom', KwFrom)

    if (!mpgReportData && Opt.app_buried) {
      mpgReportData = JSON.parse(Opt.app_buried)
    }

    if (mpgReportData) {
      return {
        ...mpgReportData,
        scene: 'app-h5',
        pid: String(PageMap[LastPage.url.split(':')[0]]),
        pids:
          mpgReportData.pids +
          ',' +
          Pages.map(a => PageMap[a.url.split(':')[0]]).join(','),
        args: JSON.stringify(LastPage.options)
      }
    } else {
      return {
        // 自定义的 小程序入口解释 字段  如： 短信   kw_from: sms
        kw_from: KwFrom,
        // 小程序自带的场景值
        scene: 'app-h5',
        // 当前页面的 页面 pid
        pid: String(PageMap[LastPage.url.split(':')[0]] || ''),
        // 当前页面的页面栈url (也就是H5中历史记录的页面url集合)
        pids: Pages.map(a => PageMap[a.url.split(':')[0]]).join(','),
        // 当前页面的url参数，有就上报
        args: JSON.stringify(LastPage.options)
      }
    }
  } catch (error) {
    console.log('开发环境关闭了上报', error)
  }
}

// 页面初始化时 上报数据
export function PageTrack({ vm, ...params }) {
  Vm = vm
  // if (process.env.NODE_ENV === 'production') {
  const hasSame = saveHistory(Vm)

  const datas = {
    // 小程序进入当前页面前的 上一次点击事件的  埋点名称 如： home_popup_list
    last_cid: uni.last_cid || '',
    ...getOptions(),
    ...params
  }
  !~hasSame && sendPageTrack(datas)
  uni.last_cid = null
  // }
}

// 点击事件触发时 上报数据
export function ClickTrack(cid) {
  cid =
    cid +
    (mpgReportData && mpgReportData.last_cid
      ? '_' + mpgReportData.last_cid
      : '')
  uni.last_cid = cid
  const datas = {
    ...getOptions(),
    cid
  }
  // if (process.env.NODE_ENV === 'production') {
  sendClickTrack(datas)
  // }
}
